import React, { useContext, useState } from 'react';
import Context from '../../../../context/context';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const CarType = (props) =>{

    const {state, dispatch} = useContext(Context);
    const [carType, setCarType] = useState(state.carType);
    const [carBackType, setCarBackType] = useState(state.carBackType);
    
    const [carTypes] = useState(state.carTypes);
    const setCarTypeDispatch = data => dispatch({type:"SET_CAR_TYPE", payload: data});
    const setCarTypeBackDispatch = data => dispatch({type:"SET_CAR_BACK_TYPE", payload: data});


    const handleChange = (event) => {
        if(props.isInviteBack){
        setCarBackType(event.target.value);
        setCarTypeBackDispatch(event.target.value)
        }else{
            setCarType(event.target.value);
        setCarTypeDispatch(event.target.value)
        }
        
    };

    return (
        <div>
             <FormControl sx={{ minWidth: 100, margin: '10px 0' }}>
                <InputLabel id="demo-simple-select-label">סוג רכב</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.isInviteBack ? carBackType : carType}
                    label="סוג רכב"
                    autoWidth
                    onChange={handleChange}
                    className="orbitSelect"
                >
                    <MenuItem value="">
                        <em></em>
                    </MenuItem>
                    {carTypes?.map((item) =>
                        <MenuItem key={item.id} value={item}>
                            {item.carTypeHebrew}
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </div> 
    )
}

export default CarType;